import { HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PageScrollModule } from '@mnz-core/modules/page-scroll/page-scroll.module';
import { StoreModule } from '@mnz-core/modules/store/store.module';
import { provideAppConfiguration } from '@mnz-core/providers/app-configuration.provider';
import { provideErrorHandler } from '@mnz-core/providers/error-handler.provider';
import { provideI18n } from '@mnz-core/providers/i18n.provider';
import { provideSentryLogger } from '@mnz-core/providers/sentry-logger.provider';
import { LoginModule } from '@mnz-modules/login/login.module';
import { SharedModule } from '@mnz-shared/shared.module';
import { AppRoutingModule } from '@mnz/app-routing.module';
import { AppComponent } from '@mnz/app.component';
import { TranslateModule } from '@ngx-translate/core';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from '@environments/environment';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    PageScrollModule,
    StoreModule,
    // Instrumentation must be imported after importing StoreModule (config is optional)
    StoreDevtoolsModule.instrument({
      maxAge: 25, // Retains last 25 states
      logOnly: environment.production, // Restrict extension to log-only mode
    }),
    LoginModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: provideI18n(),
    }),
  ],
  bootstrap: [AppComponent],
  providers: [provideErrorHandler(), provideSentryLogger(), provideAppConfiguration()],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppModule {}
